import { Button, Col, Form, Input, Row, message } from "antd";
import React, { useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";

const AuditReport = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // --- helpers ---
  const downloadBlob = (data, filename) => {
    const blob =
      data instanceof Blob
        ? data
        : new Blob([data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const ts = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
  };

  // --- submit handler: run all filled APIs ---
  const onFinish = async (values) => {
    const { profileId, customerId, applicationId, loanAccountNumber } = values;

    const tasks = [];
    if (profileId?.trim()) {
      tasks.push({
        label: "Employee",
        filename: `employee_report_${ts()}.pdf`,
        call: () =>
          props.apis.apiExportAuditForEmployee({ profileId: profileId.trim() }),
      });
    }
    if (customerId?.trim()) {
      tasks.push({
        label: "Customer",
        filename: `customer_report_${ts()}.pdf`,
        call: () =>
          props.apis.apiExportAuditForCustomer({
            customerId: customerId.trim(),
          }),
      });
    }
    if (applicationId?.trim()) {
      tasks.push({
        label: "Application",
        filename: `application_report_${ts()}.pdf`,
        call: () =>
          props.apis.apiExportAuditForApplication({
            applicationId: applicationId.trim(),
          }),
      });
    }
    if (loanAccountNumber?.trim()) {
      tasks.push({
        label: "LAN",
        filename: `lan_report_${ts()}.pdf`,
        call: () =>
          props.apis.apiExportAuditForLoanAccountNumber({
            loanAccountNumber: loanAccountNumber.trim(),
          }),
      });
    }

    if (!tasks.length) {
      message.error("Please enter at least one ID to generate reports.");
      return;
    }

    setLoading(true);
    try {
      const results = await Promise.allSettled(tasks.map((t) => t.call()));

      results.forEach((res, i) => {
        const t = tasks[i];
        if (res.status === "fulfilled" && res.value) {
          downloadBlob(res.value, t.filename);
          message.success(`${t.label} report downloaded.`);
        } else {
          message.error(`Failed to generate ${t.label} report.`);
          if (res.status === "rejected")
            console.error(`${t.label} report error:`, res.reason);
        }
      });
    } catch (e) {
      console.error(e);
      message.error("Something went wrong while generating reports.");
    } finally {
      setLoading(false);
    }
  };

  const layout = { labelCol: { span: 8 }, wrapperCol: { span: 16 } };
  const validateMessages = { required: "${label} is required!" };

  // Optional exposure
  props.$setNode?.({ props });

  return (
    <>
      <MainPagetitle
        mainTitle="Reports"
        back={"Audit Report"}
        backLink={`/app/auditreport`}
        pageTitle={"Audit Report"}
        parentTitle={"Home"}
        pageIcon={imagepaths.reportsIconActive}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container">
                  <h4 className="heading mb-0">Generate Audit Format</h4>
                  <p className="text-muted mb-0">
                    Fill one or more fields; we’ll generate each report.
                  </p>
                </div>

                <Form
                  {...layout}
                  form={form}
                  name="audit_report_form"
                  onFinish={onFinish}
                  style={{ maxWidth: 600 }}
                  validateMessages={validateMessages}
                >
                  {/* Not marking required—multiple optional fields allowed */}
                  <Form.Item name={["profileId"]} label="Employee ID">
                    <Input placeholder="Enter Employee ID" />
                  </Form.Item>

                  <Form.Item name={["customerId"]} label="Customer ID">
                    <Input placeholder="Enter Customer ID" />
                  </Form.Item>

                  <Form.Item name={["applicationId"]} label="Application ID">
                    <Input placeholder="Enter Application ID" />
                  </Form.Item>

                  <Form.Item
                    name={["loanAccountNumber"]}
                    label="Loan Account No."
                  >
                    <Input placeholder="Enter Loan Account No." />
                  </Form.Item>

                  <Row className="mb-5">
                    <Col md={8}></Col>
                    <Col md={8}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary btn-sm"
                        loading={loading}
                        disabled={loading}
                      >
                        {loading ? "Generating..." : "Download Pdf(s)"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(AuditReport);
